import React, { Fragment, StrictMode } from "react";
import { hot } from "react-hot-loader/root";
import { Meta } from "@sicredi/react";
import { Routes } from "#/routes";

export const App: React.FC = () => {
  return (
    <Fragment>
      <Meta titleTemplate="%s - Sicredi" defaultTitle="Sicredi" />

      <main>
        <StrictMode>
          <Routes />
        </StrictMode>
      </main>
    </Fragment>
  );
};

export default hot(App);
